<template>
  <c-flex align="center" flex="1" z-index="popover" position="relative">
    <c-box @click="focusField">
      <c-icon name="search" size="2rem" mr="md" :color="textColor" />
    </c-box>
    <c-box z-index="popover">
      <c-input
        width="14rem"
        z-index="popover"
        id="globalSearchField"
        ref="globalSearchField"
        position="relative"
        px="0"
        h="34px"
        :is-full-width="true"
        bg="transparent"
        :color="textColor"
        :_placeholder="{ color: textColor }"
        border-radius="0"
        border-width="0px"
        border-bottom-width="1px"
        :border-bottom-color="textColor"
        focus-border-color="transparent"
        v-model="data.searchTerm"
        type="text"
        autocomplete="off"
        :placeholder="$t('globalSearch.placeholder')"
        @keydown="onSearchTermUpdated(data.searchTerm)"
        @keyup="onSearchTermUpdated(data.searchTerm)"
        @blur="onSearchTermUpdated(data.searchTerm)"
        @keydown.esc="data.searchTerm = ''"
        @focus="onFocus"
        :_hover="{ borderBottomColor: highlightColor }"
        :_focus="{ borderBottomColor: highlightColor }"
        :_active="{ borderBottomColor: textColor }"
      />
    </c-box>
  </c-flex>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import _ from "lodash";
import { mapState } from "vuex";
import { CIcon, CBox, CFlex, CText, CHeading, CInput } from "@chakra-ui/vue";
import { IGlobalSearchState } from "@/store/globalSearchModule";
import { PartnerTier, PartnerTierType } from "@iloq/shared/IPartnerInfo";

export default defineComponent({
  name: "GlobalSearch",
  components: {
    CIcon,
    CBox,
    CFlex,
    CText,
    CHeading,
    CInput,
  },
  props: {
    tier: {
      type: String as PropType<PartnerTierType>,
      default: null,
    },
  },
  data() {
    return {
      data: {
        searchTerm: "",
        lastSearchTerm: "x",
      },
      typing: false,
    };
  },
  computed: {
    ...mapState("globalSearch", {
      searchTerm: (state: unknown) => (state as IGlobalSearchState).searchTerm,
    }),
    textColor() {
      if (this.tier === PartnerTier.PLATINUM) {
        return "brand.purple";
      }
      return "white";
    },
    highlightColor() {
      if (this.tier === PartnerTier.PLATINUM) {
        return "brand.purpleLight";
      }
      return "brand.yellow";
    },
  },
  watch: {
    searchTerm() {
      this.onSearchTermUpdatedInStore();
    },
  },
  mounted() {
    this.data.searchTerm = this.searchTerm;
    this.data.lastSearchTerm = this.searchTerm;
  },
  methods: {
    onSearchTermUpdated(term: string) {
      if (term?.trim() !== (this.data.lastSearchTerm || "").trim()) {
        this.typing = true;

        // The following prevents wrong/old results to be displayed
        this.$store.dispatch("globalSearch/updateSearchTermWithoutSearching", term);

        this.search(term);
      }
    },
    onSearchTermUpdatedInStore() {
      if (this.data.searchTerm.trim() !== this.searchTerm) {
        this.data.searchTerm = this.searchTerm;
      }
    },
    search: _.debounce(function (this: any, term: string) {
      if (term !== this.data.lastSearchTerm) {
        this.data.lastSearchTerm = term;
        this.$store.dispatch("globalSearch/updateSearchTerm", term);
        this.typing = false;
      }
    }, 400),
    focusField() {
      (this.$refs.globalSearchField as any)?.$el.focus();
    },
    onFocus() {
      if (this.data.searchTerm.trim().length) {
        this.$store.commit("globalSearch/setOverlayVisibility", true);
      }
    },
  },
});
</script>
